import GET_ARTICLES from '../plugins/getArticles'

const [ w, d ] = [ window, document ];

const init = () => {

  if( w.load[ 'loadHtml' ]) {

    w.load[ 'loadHtml' ].then( () => {
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    });

  }

}

export default function QUALITY() {
  $( init )
}